import React from 'react'
import styled from '@emotion/styled'
import { string, element } from 'prop-types'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const Wrapper = styled.div`
	background: ${({ background }) => background};
	display: inline-block;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		min-height: 200px;
		height: 20vh;
		display: inline-block;
	}

	@media (min-width: 768px) and (max-width: 995px) {
		height: 30vh;
		min-height: 250px;
	}

	${({ theme }) => theme.MQ.MAX} {
		max-height: 200px;
		min-height: 200px;
	}
`
const CtaLink = styled(Link)`
	align-items: center;
	display: flex;
	height: 100%;

	&:hover {
		.LearnMore {
			color: ${({ theme }) => theme.colors.primary};
		}
	}
`
const WrapperSub = styled.div`
	display: block;
	padding-top: 0;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		display: inline-block;
		width: 70%;
	}
`
const CtaWrapper = styled.div`
	padding: 10px 30px 30px;

	${({ theme }) => theme.MQ.M} {
		align-items: center;
		display: flex;
		padding: 10px;
	}
`
const IconWrapper = styled.div`
	display: block;
	margin: auto;
	text-align: center;
	width: 40%;

	${({ theme }) => theme.MQ.M} {
		display: inline-block;
		width: 30%;
	}
`
const Title = styled.div`
	${({ theme }) => theme.header.h3};
	color: #ffffff;
	margin: 0;
	padding-bottom: 5px;
	text-align: center;

	${({ theme }) => theme.MQ.M} {
		text-align: left;
	}
`
const Description = styled.div`
	color: #ffffff;
	height: 100%;
	margin: auto;
	text-align: center;
	width: 85%;

	@media (min-width: 790px) and (max-width: 992px) {
		height: 110px;
	}

	${({ theme }) => theme.MQ.M} {
		height: 100px;
		margin: 0;
		min-height: 100px;
		text-align: left;
	}

	${({ theme }) => theme.MQ.L} {
		height: 70px;
		min-height: 70px;
	}

	@media (min-width: 768px) and (max-width: 800px) {
		min-height: 60px;
		width: 90%;
	}

	@media (min-width: 1200px) and (max-width: 1300px) {
		height: 65px;
		min-height: 60px;
	}

	@media (min-width: 1500px) {
		height: 65px;
		min-height: 60px;
		width: 65%;
	}
`
const LearnMore = styled.div`
	${({ theme }) => theme.text.sectionHeaderSmall};
	color: ${({ theme }) => theme.colors.secondary};
	padding-top: 20px;
	text-align: center;

	${({ theme }) => theme.MQ.M} {
		padding-top: 10px;
		text-align: left;
	}

	@media (min-width: 1200px) {
		padding-top: 5px;
	}
`

CardLongCta.propTypes = {
	background: string,
	cta: string,
	description: string,
	icon: element,
	path: string,
}

/**
 * This Component is the Long Card
 *
 * This card is entirely clickable long card
 * It takes in a icon, title, short blurb and background color
 * At the bottom of the card it reads "Learn More" (can change)
 */
function CardLongCta({ background, cta, description, icon, path }) {
	return (
		<Wrapper background={background}>
			<CtaLink aria-label={cta} href={path}>
				<CtaWrapper>
					<IconWrapper>{icon}</IconWrapper>
					<WrapperSub>
						<Title> {cta} </Title>
						<Description> {description} </Description>
						<LearnMore className="LearnMore">Learn More</LearnMore>
					</WrapperSub>
				</CtaWrapper>
			</CtaLink>
		</Wrapper>
	)
}

export default CardLongCta
